// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-checklist2-report {
  height: 100%;
  display: block;
  overflow: hidden;
}
.fi-checklist2-report .fi-content {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/checklist/fi-checklist2-report/fi-checklist2-report.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,cAAA;EACA,gBAAA;AACJ;AAAI;EACI,YAAA;AAER","sourcesContent":[".fi-checklist2-report {\r\n    height: 100%;\r\n    display: block;\r\n    overflow: hidden;\r\n    .fi-content {\r\n        height: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
